import siteVars from './siteVars'
import posthog from 'posthog-js'
import Rum from './rum'
import axios from '~/data/http/axios'
class PostHogFunctions {
    static init() {
        try {
            if (window.location.host.indexOf('localhost') > -1) {
                //disabling posthog for local for now
                return
            }
            if (!siteVars.postHogKey || !siteVars.postHogUrl) {
                return
            }
            if (!posthog.__loaded) {
                posthog.init(siteVars.postHogKey, {
                    api_host: siteVars.postHogUrl,
                    capture_pageview: false,
                    session_recording: {
                        maskAllInputs: true,
                        maskTextSelector: '*'
                    },
                    disable_session_recording: true
                })
                return posthog.get_session_id()
            }
        } catch (err) {
            return null
        }
    }

    static clear() {
        try {
            if (!siteVars.postHogKey || !siteVars.postHogUrl) {
                return
            }
            if (posthog.__loaded) {
                posthog.reset()
            }
        } catch (err) {}
    }

    static async ident(user, account) {
        try {
            if (!siteVars.postHogKey || !siteVars.postHogUrl) {
                return
            }
            if (posthog.__loaded) {
                await axios.put('/accountMaster/posthog/company/ident', {})
                posthog.group('company', account.id, {
                    name: account.accountMaster.accountName
                })

                const data = {
                    email: user.userData.emailAddress,
                    createdAt: user.userData.createdAt,
                    accountMasterId: account.id,
                    accountMasterName: account.accountMaster.accountName,
                    accountType: account.accountMaster.accountType || 'Unknown',
                    accountBillingTierName: account.accountMaster.accountBillingTierName || 'Unknown',
                    billingName: account.accountMaster.billingName || 'Unknown',
                    industry: account.accountMaster.industry || 'Unknown'
                }

                const answers = await axios.get('/accountMaster/questions/answers')
                if (answers.data) {
                    data.onboarding = {
                        'company-role': answers.data.answers.role,
                        'comfort-level': answers.data.answers.comfort,
                        'important-to-business': answers.data.answers.importantToBusiness
                    }
                }

                posthog.identify(user.userID, data)
            }
        } catch (err) {}
    }
    static async capture(eventName, data) {
        if (!siteVars.postHogKey || !siteVars.postHogUrl) {
            return
        }
        try {
            if (posthog.__loaded) {
                posthog.capture(eventName, data)
            }
        } catch (err) {}
    }

    static async enableRecording() {
        if (!siteVars.postHogKey || !siteVars.postHogUrl) {
            return
        }
        try {
            if (posthog.__loaded) {
                posthog.startSessionRecording({ sampling: true })
                Rum.addLabelsGlobal({
                    posthog: true
                })
            }
        } catch (err) {}
    }
}
export default PostHogFunctions
